import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { map, switchMap, withLatestFrom } from 'rxjs/operators';
import { AttendanceGridService } from '../../../shelter/grid/attendance/services/attendance-grid.service';
import {
  LoadShelterDataSuccess,
  LOAD_SHELTER_DATA,
  SaveShelterData,
} from '../../actions/shelter-actions/shelter-actions';

@Injectable()
export class ShelterDataEffects {
  constructor(
    private actions$: Actions,
    private attendanceGridService: AttendanceGridService,
    private store: Store<any>,
  ) {}

  @Effect()
  loadShelterData$ = this.actions$.pipe(
    ofType<any>(LOAD_SHELTER_DATA),
    switchMap(data => {
      const {
        payload: { shelterId },
      } = data;
      return this.attendanceGridService.getShelterGridConfig$(shelterId);
    }),
    withLatestFrom(this.store),
    switchMap(([config, storeState]) => {
      const {
        data: { ShelterGridConfig: columnDefs },
      } = config;
      const {
        PORTAL_STORE: {
          shelterData: { shelterId },
        },
      } = storeState;
      this.store.dispatch(new SaveShelterData({ columnDefs }));
      const payload = this.attendanceGridService.getShelterGridDataPayload(columnDefs, shelterId);
      return of(payload);
    }),
    switchMap(payload => {
      return this.attendanceGridService.getShelterGridData$(payload);
    }),
    map(data => {
      const {
        data: { ShelterGridData: rowData },
      } = data;
      this.store.dispatch(new SaveShelterData({ rowData }));
      return new LoadShelterDataSuccess({});
    }),
  );
}
